import { render, staticRenderFns } from "./conversations.vue?vue&type=template&id=2d802280"
import script from "./conversations.vue?vue&type=script&lang=js"
export * from "./conversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports